import _ from 'lodash';
import moment from 'moment-business-days';

export const getResponsiveSrc = (newVal, maxWidth = null, fallback = null) => {
    if (!newVal || _.isString(newVal)) {
        return _.defaultTo(newVal, fallback);
    }

    let url = null;

    if (Object.keys(newVal).length) {
        if (maxWidth) {
            _.forEach(newVal, (item, width) => {
                if (maxWidth <= width && url === null) {
                    url = item;
                }
            });
        }
    }

    return _.defaultTo(url, fallback);
};

export const formatDate = (date, format) => {
    if (moment.isMoment(date)) {
        return date.format(format);
    } else {
        date = _.get(date, 'date', date).replace('.000000', '');

        if (moment(date, 'YYYY-MM-DD HH:mm:SS').format('YYYY-MM-DD HH:mm:SS') === date) {
            return moment.utc(date, 'YYYY-MM-DD HH:mm:SS').format(format);
        }

        return moment.utc(date).format(format);
    }
};

export const guessFileType = (file) => {
    if (!file) return;
    file = file.name ? file.name : file;
    file = `${file}`.toLowerCase();

    if (/\.(gif|png|jpe?g)$/i.test(file)) {
        return 'image';
    }
    if (/\.(htm|html)$/i.test(file)) {
        return 'html';
    }
    if (/\.(docx?|xlsx?|pptx?|pps|potx?)$/i.test(file)) {
        return 'office';
    }
    if (/\.(rtf|docx?|xlsx?|pptx?|pps|potx?|ods|odt|pages|ai|dxf|ttf|tiff?|wmf|e?ps)$/i.test(file)) {
        return 'gdocs';
    }
    if (/\.(txt|md|csv|nfo|php|ini)$/i.test(file)) {
        return 'text';
    }
    if (/\.(og?|mp4|mov|webm|avi)$/i.test(file)) {
        return 'video';
    }
    if (/\.(ogg|mp3|wav)$/i.test(file)) {
        return 'audio';
    }
    if (/\.(swf)$/i.test(file)) {
        return 'flash';
    }
    if (/\.(pdf)$/i.test(file)) {
        return 'pdf';
    }

    return 'other';
};

/**
 *
 * @param start
 * @param end
 * @param string
 * @returns {Array}
 */
window.dateRange = function (start, end, string = false) {
    let startDate = dateTimeObject(start);
    let endDate = dateTimeObject(end);
    let dates = [];
    do {
        if (string) {
            dates.push(dateTimeObject(startDate));
        } else {
            dates.push(dateTimeString(startDate, 'date'));
        }
    } while (startDate.add(1, 'days').diff(endDate) <= 0);

    return dates;
};

/**
 *
 * @param start
 * @param end
 * @param callback
 * @returns {Array}
 */
window.dateRangeLoop = function (start, end, callback) {
    let startDate = dateTimeObject(start);
    let endDate = dateTimeObject(end);
    let response = [];
    do {
        response.push(callback(startDate, endDate));
    } while (startDate.add(1, 'days').diff(endDate) <= 0);

    return response;
};

/**
 *
 * @param date
 * @param assumeUtc
 * @returns {*}
 */
window.dateTimeObject = function (date = null, assumeUtc = true) {
    date = date === null ? moment() : date;

    if (moment.isMoment(date)) {
        return date.clone();
    }

    if (assumeUtc) {
        return moment.utc(date);
    }

    return moment(date);
};

/**
 *
 * @param date
 * @param format
 * @param assumeUtc
 * @param toLocal
 * @returns {*}
 */
window.dateTimeString = function (date = null, format = 'date', assumeUtc = true, toLocal = false) {
    date = dateTimeObject(date, assumeUtc);
    format = format ? format : 'L';

    if (format === 'date') {
        format = 'YYYY-MM-DD';
    }

    if (format === 'time') {
        format = 'LT';
    }

    if (format === 'datetime') {
        format = 'L LT';
    }

    if (toLocal) {
        return date.local().format(format);
    }

    return date.format(format);
};

/**
 *
 * @param title
 * @param callback
 * @param options
 */
window.swalc = function (title, callback, options = {}) {
    let html = '';
    if (Array.isArray(title)) {
        html = title[1];
        title = title[0];
    }
    swal(
        _.merge(
            {
                title: title,
                html: html,
                type: 'warning',
                confirmButtonClass: 'btn btn-danger mr-2',
                cancelButtonClass: 'btn btn-cancel',
                buttonsStyling: false,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
            },
            options,
        ),
    ).then((result) => {
        callback(result.value);
    });
};

export default { getResponsiveSrc, guessFileType };
